<template>
  <el-dialog custom-class="dialog-modal-permission" :model-value="flagVisible" width="770px" :before-close="handleClose">
    <div class="modal-permission">
      <div class="modal-p-content text-that-needs-wrapping">
        <div class="modal-p-title">
          <span>More products in each Player!</span>
        </div>
        <div class="modal-p-desc">
          <p>Keep your user’s visit efficient by providing all your products in one place.</p>
          <p>Contact <a href="mailto:sales@audiotestkitchen.com">sales@audiotestkitchen.com</a> to increase the number of products available for comparision in each Player instance.</p>
        </div>
      </div>
      <div class="modal-p-img">
        <img src="@/assets/images/permissions/products.png" alt="" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    flagVisible: Boolean
  },
  emits: ['closeModal'],
  data: function () {
    return {
    }
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    }
  }
}
</script>
